
jQuery(function ($) {

    console.log('Working 1.0.11');
    var cart_hash_key = pixelperfect.cart_hash_key;
    console.log('pixelperfect', pixelperfect);

    const wv = $(window).width();

    class PopupNotice {
        constructor(labels, attributes) {
            this.enabled = attributes.enabled;
            this.attributes = attributes.terms;
            this.title = labels.title;
            this.text = labels.body;
            this.backButtonLabel = labels.back_button_label;
            this.proceedButtonLabel = labels.proceed_button_label;
        }

        selectPremium() {
            document.getElementById('wellis_new_premium_option').checked = true;
            this.closePopup();
        }

        resetVariation() {
            let reset_link = document.getElementsByClassName('reset_variations');
            for (const link of reset_link) {
                link.click();
            }
            this.closePopup();
        }

        checkPremium() {
            let premium = document.getElementById("wellis_new_premium_option").checked;
            let premium_plus = document.getElementById("wellis_new_premium_plus_option").checked;
            return premium || premium_plus;
        }

        variationChange(_variation) {
            if (!this.enabled) {
                return false;
            }

            let att = this.attributes;
            if (typeof att === 'object' && att !== null) {
                att = Object.entries(att).map(
                    (entry) => entry[1]
                );
                console.log(att)
            }

            for (const attribute of att) {
                //console.log(attribute.slug, _variation.attributes.attribute_pa_colors);
                if (attribute.slug === _variation.attributes.attribute_pa_colors) {
                    //console.log('Premium required');
                    if (this.checkPremium()) {

                    } else {
                        this.createPopup();
                    }

                    return true;
                }
            }
            //console.log('proceed ...');
            return false;
        }

        createPopup() {
            // Create elements
            this.popupContainer = document.createElement('div');
            this.popupContainer.classList.add('pixelperfect-popup-container');

            this.popup = document.createElement('div');
            this.popup.classList.add('popup');

            this.popupTitle = document.createElement('h2');
            this.popupTitle.textContent = this.title;

            this.popupText = document.createElement('p');
            this.popupText.textContent = this.text;

            this.actions = document.createElement('div');
            this.actions.classList.add('actions');

            this.closeButton = document.createElement('button');
            this.closeButton.textContent = this.backButtonLabel;
            this.closeButton.classList.add('back');
            this.closeButton.addEventListener('click', this.resetVariation.bind(this));

            this.proceedButton = document.createElement('button');
            this.proceedButton.textContent = this.proceedButtonLabel;
            this.proceedButton.classList.add('proceed');
            this.proceedButton.addEventListener('click', this.selectPremium.bind(this));

            // Assemble elements
            this.popup.appendChild(this.popupTitle);
            this.popup.appendChild(this.popupText);
            this.popup.appendChild(this.actions);
            this.actions.appendChild(this.closeButton);
            this.actions.appendChild(this.proceedButton);
            this.popupContainer.appendChild(this.popup);

            // Add to the document
            document.body.appendChild(this.popupContainer);

            // Trigger reflow to enable transition
            this.popup.offsetWidth; // This forces the browser to recalculate the styles
            this.popupContainer.classList.add('popup-open');
        }

        closePopup() {
            this.popupContainer.classList.remove('popup-open');
            this.popup.addEventListener('transitionend', () => {
                document.body.removeChild(this.popupContainer);
            }, { once: true });
        }
    }
    // Example usage
    if (pixelperfect.localized.premium_notice && pixelperfect.premium_attributes) {
        const premiumVariationsPopup = new PopupNotice(pixelperfect.localized.premium_notice, pixelperfect.premium_attributes);

        $('.single_variation_wrap').on('show_variation', function (event, variation) {
            premiumVariationsPopup.variationChange(variation);
        });
    }

    if ($('body').hasClass('single-product') && wv < 700) {
        $(".variations_form").insertAfter(".extra-info");
    }

    if ($('body').hasClass('archive')) {
        $('.wp-block-woocommerce-product-categories .wc-block-product-categories-list-item__name').each(function (index) {
            if ($(this).text() == pixelperfect.active_cat) {
                $(this).closest('li').addClass('active-cat');
                select_parent($(this));
            }
        });
    }

    if ($('.archive.desc').length > 0) {
        let elem = $('.archive.desc .term-description');
        if (elem.height() > 70) {
            $('.archive.desc').addClass('has-btn').addClass('closed');
            $('.archive.desc .btn').html($('.archive.desc .btn').attr('data-closed'));

            $(document).on('click', '.archive.desc .btn', function (e) {
                $('.archive.desc').toggleClass('closed');
                if ($('.archive.desc').hasClass('closed')) {
                    $(this).html($(this).attr('data-closed'));
                } else {
                    $(this).html($(this).attr('data-open'));
                }
            });
        }
    }

    // if( $('.premium-plus-button').length > 0 ){
    //     console.log('...');
    //     $(document).on('click', '.premium-button', function(e){
    //         $('#wellis_new_premium_plus_option').prop('checked', false);
    //     });
    //     $(document).on('click', '.premium-plus-button', function(e){
    //         $('#wellis_new_premium_option').prop('checked', false);
    //     });
    // }

    if ($('#wellis_filter').length > 0) {
        //filter_products();
    }

    $(document).on('click', '.toggle-filter-btn', function (e) {
        //filter_products();
        if ($('body').hasClass('mobile-filter-closed')) {
            $('body').removeClass('mobile-filter-closed');
            setTimeout(function () {
                $('body').removeClass('filter-closed');
            }, 200);
        }

    });

    function filter_products() {

        var filters = {
            filter_jets: [],
            filter_loungers: [],
            filter_massage_pumps: [],
            filter_size: []
        };

        $('#wellis_filter input:checked').each(function (index) {
            let name = $(this).attr('name');
            let val = $(this).val();

            filters[name].push(val);
        });

        //console.log('Filter products', filters);

        fetch(pixelperfect.ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: 'action=wellis_process_filters&filters=' + JSON.stringify(filters)
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
            })
            .catch(err => console.log(err))
    }

    function select_parent(_this) {
        let $parent = _this.closest('ul:not(.active-cat)');
        $parent.addClass('active-cat');
        $parent.closest('li.wc-block-product-categories-list-item').addClass('active-cat');

        if ($parent.closest('ul').hasClass('.wc-block-product-categories-list')) {
            console.log('got the base ....');
        } else {
            //select_parent(_this);
        }
    }

    var plist, sbar;

    let product_list = $('body.archive main > .products');
    let sidebar = $('#sidebar .inner');

    if (sidebar.height() > product_list.height()) {
        //console.log('if');
    } else {
        //console.log('else');
    }
    sbar = new Sticky('#sidebar > .inner');

    var gallery = new Sticky('#wellis_product_gallery');

    if (window.innerWidth > 750) {
        var stickies = new Sticky('.stick-it');
    }

    if ($('#product_menu').length > 0) {
        var product_menu = $('#product_menu');
        var stickyTop = product_menu.height() + product_menu.offset().top;

        $(window).scroll(function () {
            var windowTop = $(window).scrollTop();
            if (stickyTop < windowTop) {
                product_menu.addClass('sticky');
            } else {
                product_menu.removeClass('sticky');
            }
        });
    }

    if ($('#requestaquote').length > 0) {
        $('#requestaquote .quote-field-sku input').val($('.sku_wrapper .sku').html());
        $(document).on('click', '#requestaquote .close', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('body').removeClass('quote-open');
        });
    }

    $(document).on('click', '.toggle-btn', function (e) {
        e.stopPropagation();
        $('body').toggleClass($(this).attr('data-toggle-class'));
    });

    $(document.body).on("wc_additional_variation_images_frontend_lightbox_done ",
        function (e) {
            console.log('event: ', e.type)
            slickProductGallery();
        }
    )

    /*Wellis add to cart*/
    $(document).on('click', '#add_items_to_cart, .single_add_to_cart_button', function (e) {

        console.log('Add to cart');

        let $this = $(this);
        let $form = $this.closest('form.cart');
        let product_id = $form.find('input[name=product_id]').val();
        let variation_id = $form.find('input[name=variation_id]').val();
        let product_qty = $form.find('input[name=quantity]').val() || 1;
        let wellis_new = [];
        let wellis_additional = [];
        let wellis_gifts = [];

        $form.find('input[name="wellis_new"]').each(function () {
            //wellis new
            if ($(this).is(':checked')) {
                wellis_new.push({
                    'name': $(this).attr('data-name'),
                    'price': $(this).val(),
                });
            }

            if ($(this).hasClass('gift')) {
                wellis_new.push({
                    'name': $(this).attr('data-name'),
                    'price': $(this).val(),
                });
            }
        });

        $form.find('input[name="wellis_additional"]').each(function () {
            if ($(this).is(':checked')) {
                wellis_additional.push($(this).val());
            }
        });

        if (pixelperfect.enable_catalog_mode || $(this).hasClass('request-a-quote')) {

        } else {

            if ((product_id && wellis_additional.length) || (product_id && wellis_new.length)) {
                e.preventDefault();
            } else {
                return;
            }

        }

        e.preventDefault();
        e.stopPropagation();

        if (pixelperfect.enable_catalog_mode || $(this).hasClass('request-a-quote')) {
            $('body').addClass('quote-open');
        } else {
            $(this).attr('disabled', true);
        }

        let cart_items = {
            'product_id': product_id,
            'variation_id': variation_id,
            'product_qty': product_qty,
            'wellis_new': wellis_new,
            'wellis_additional': wellis_additional
        };

        //console.log('wellis_new', wellis_new);
        //console.log('wellis_additional', wellis_additional);
        //console.log('cart_items', cart_items);

        if (pixelperfect.enable_catalog_mode || $(this).hasClass('request-a-quote')) {

        } else {
            fetch(pixelperfect.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: 'action=wellis_add_to_cart_with_additions&cart_items=' + JSON.stringify(cart_items)
            })
                .then(response => response.json())
                .then(data => {
                    refresh_fragmentss(data.cart_hash);

                    console.log(data);
                    let fragments = data.fragments;

                    if (fragments) {

                        $('#mobile-cart-link').replaceWith(fragments.badge);
                        if ($('#minicart .widget_shopping_cart_content').length < 1) {
                            console.log('van minicart div', false)
                            $('#minicart .inner .woocommerce-mini-cart__empty-message').hide()
                            $('#minicart .inner').append('<div class="widget_shopping_cart_content"></div>')
                        }
                        $('#minicart .widget_shopping_cart_content').replaceWith(fragments.minicart);
                        $('body').addClass('mini-cart-open');
                    }

                    $(document.body).trigger('wc_fragment_refresh');
                    $(this).attr('disabled', false);

                })
                .catch(err => console.log(err))
        }
    });

    $(document.body).on('removed_from_cart updated_cart_totals', function () {
        console.log('removed_from_cart updated_cart_totals');
        $(document.body).trigger('wc_fragment_refresh');
    });

    function refresh_fragmentss(cart_hash_key) {
        // Better to put there 'blank' string then empty string
        //window.sessionStorage.setItem(cart_hash_key, 'blank');
        var e = $.Event("storage");

        e.originalEvent = {
            key: cart_hash_key,
        };

        $(window).trigger(e);
    }

    refresh_fragmentss();
    //setInterval(refresh_fragmentss, 60000);

    function slickProductGallery() {

        $('.woocommerce-product-gallery__wrapper').each(function (index) {
            if ($(this).hasClass('slick-initialized')) {

            } else {
                var html = '<div class="flex-slider-nav" data-aos="fade-in">';
                $(this).find('.woocommerce-product-gallery__image').each(function (index) {

                    let url = $(this).attr('data-thumb');
                    html += '<span><img src="' + url + '" alt="" /></span>';

                });
                html += '</div>';

                $(this).parent().append(html);

                $(this).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true,
                    arrows: false,
                    dots: true,
                    asNavFor: '.flex-slider-nav'
                });
                $(this).parent().find('.flex-slider-nav').slick({
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    prevArrow: '<div class="slick-prev slick-arrow"><i class="mdi mdi-chevron-up"></i></div>',
                    nextArrow: '<div class="slick-next slick-arrow"><i class="mdi mdi-chevron-down"></i></div>',
                    asNavFor: '.woocommerce-product-gallery__wrapper',
                    dots: false,
                    vertical: true,
                    centerMode: true,
                    verticalSwiping: true,
                    focusOnSelect: true
                });
            }
        });
    }

    slickProductGallery();

    $('a.woocommerce-terms-and-conditions-link').on('click touchend', function (event) {
        event.preventDefault();
        window.location.href = $(this).attr('href');
        return false;
    });

    $(document).on('found_variation', 'form.cart', function (event, variation) {

        var match = $('#' + variation.image_id).closest('.slick-slide').attr('id');
        //console.log(variation);
        //console.log(match);
        if (match) {
            $('.woocommerce-product-gallery__wrapper').slick('slickGoTo', parseInt(match.replace('slick-slide', '')));
        }
    });
    /*
        $('#lifestyle_gallery, .attribute-gallery').slick({
            //slidesToShow: 1,
            //slidesToScroll: 1,
            arrows: false,
            dots: true,
            //centerMode: true,
            variableWidth: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 700,
                    settings: {
                        dots: false
                    }
                }
            ]
        });
        Changed to Flickity slider
     */

    $('#lifestyle_gallery, .attribute-gallery').flickity({
        freeScroll: true,
        wrapAround: true,
        pageDots: true,
        lazyLoad: 5,
        accessibility: true
    });


    var ws = getWS();
    var ww = window.innerWidth;
    var lastBreakPoint = ws;

    /*
    $('#hero_slider').slick({
        autoplay: true,
        arrows: false,
        dots: false,
        draggable: true,
        fade: true,
        pauseOnHover: false
    });
       */
    $('#hero_slider').on('afterChange', function (event, slick, currentSlide) {
        $('#hero_slider').toggleClass('animating');
    });

    $('#offers .slider').slick({
        autoplay: true,
        arrows: false,
        dots: true,
        draggable: true,
        pauseOnHover: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true
                }
            },
        ]
    });

    $('#category_slider .slider').slick({
        autoplay: true,
        arrows: false,
        dots: ($('#category_slider .slider .item').length > 3) ? true : false,
        draggable: true,
        pauseOnHover: true,
        slidesToShow: 3,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: ($('#category_slider .slider .item').length > 1) ? true : false
                }
            },
        ]
    });

    $(document).on('click', '.mobile-search', function (e) {
        $('body').addClass('search-open');
    });
    $(document).on('click', '#site_search .close', function (e) {
        $('body').removeClass('search-open');
    });


    function getWS() {
        let ww = window.innerWidth;
        let wh = window.innerHeight;
        if (ww >= 1 && ww <= 320) { ws = 'xs'; }
        if (ww >= 321 && ww <= 720) { ws = 'sm'; }
        if (ww >= 721 && ww <= 1024) { ws = 'md'; }
        if (ww >= 1025 && ww <= 1216) { ws = 'lg'; }
        if (ww >= 1217 && ww <= 1407) { ws = 'xl'; }
        if (ww >= 1408) { ws = 'xxl'; }

        if (lastBreakPoint === ws) {
        } else {
            resizeUI();
        }
        lastBreakPoint = ws;
    }

    function resizeUI() {
        //console.log('UI needs to be resized', ws);
    }

    /*
    * Initialise MEGA MENU positions and functionality
    * */
    $('#mega_menu .container > .mega-menu-item').each(function (index) {
        let attr = $(this).attr('data-target');
        let target = $('#' + attr);
        //set position
        //$(this).css('left', (target.offset().left - $(this).find('.img-wrapper').width() - 20 ) + 'px');
        target.addClass('has-mega-menu');
        target.append($(this));

    });

    /**
     * MINI CART & AJAX ADD TO CART
     * */

    $(document.body).on('added_to_cart removed_from_cart', function (event, fragments, cart_hash, button) {
        var product_id = button.data('product_id'),   // Get the product id
            product_qty = button.data('quantity'),     // Get the quantity
            product_sku = button.data('product_sku'),  // Get the product sku
            product_name = button.data('product_name'), // Get the product name
            product_price = button.data('product_price'), // Get the product price
            currency = button.data('currency');     // Get the currency

        // For testing: View all product available data on console log (to be removed)
        console.log('event:', event);
        //console.log( button.data() );
        $('#minicart .inner').html(fragments['div.widget_shopping_cart_content']);
        $('#minicart .inner').prepend('<header><h2>Kosaram</h2><i class="mdi mdi-close close-minicart-btn"></i></header>');


        if ($('body').hasClass('mini-cart-open')) {

        } else {
            $('body').addClass('mini-cart-open');
        }

        $('#masthead .btn-cart .count').html(fragments['cart-item-count']);
        $('#masthead .free-shipping-note').html(fragments['free-shipping-notice']);
        $('#masthead .btn-cart .count').addClass('padd');
        setTimeout(function () {
            $('#masthead .btn-cart .count').removeClass('padd');
        }, 300);

    });
    //Out of minicart click
    $(document).on('click', '#minicart', function (e) {
        console.log(e.target.className);
        console.log(e.target.id);
        if (e.target.className == '' && e.target.id == 'minicart') {
            //console.log('######################');
            $('body').removeClass('mini-cart-open');
        }
    });
    //Close button
    $(document).on('click', '#minicart .close-minicart-btn', function (e) {
        $('body').removeClass('mini-cart-open');
    });
    //open button
    $(document).on('click', '#masthead .btn-cart', function (e) {
        $('body').addClass('mini-cart-open');
    });

    /**
     * MOBILE MENU
     * **/

    //populate mobile menu with cloned items
    $('#masthead #lang_select').clone().appendTo('#mobile-menu .inner');
    $('#masthead #menu-primary-menu').clone().appendTo('#mobile-menu .inner');

    //Append chevron
    $('#mobile-menu li.has-mega-menu > a').append('<i class="mdi mdi-chevron-right"></i>');

    $(document).on('click', '#mobile-menu a', function (e) {
        let href = $(this).attr('href');
        if (href === '#') {
            e.preventDefault();
            console.log('just open it ...');
            $(this).parent().toggleClass('mega-menu-open');
        } else {
            console.log('navigate to ', href);
        }
    });

    //Hide every .sub-menu
    //$('#mobile_menu .sub-menu').hide();

    /**
     * SUB MENU - MEGA MENU
     * **/

    $('#menu-primary.menu li.mega-menu .sub-menu').each(function (index) {
        let num = $(this).find('.sub-menu').length;

        if (num > 0) {
            $(this).addClass('elem-' + num);
            $(this).wrap('<div class="mega-menu-wrapper"></div>');
        }
    });

    $('#product_menu a').click(function () {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - 80
        }, 300);
        return false;
    });

    /*
    * Setting up mobile menu
    * */

    disableScroll()

    /*
    * DISABLE SCROLLING
    * */
    var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

    function preventDefault(e) {
        e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }

    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
        window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            get: function () { supportsPassive = true; }
        }));
    } catch (e) { }

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    // call this to Disable
    function disableScroll() {
        window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
        window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
        window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    // call this to Enable
    function enableScroll() {
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
        window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
        window.removeEventListener('touchmove', preventDefault, wheelOpt);
        window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    }

});
